import React, { useCallback, useContext, useMemo } from 'react';

// DEPENDENCIES
import { useFormikContext } from 'formik';

// GLOBAL VARIABLES
import { NEW_USED, RETAIL_WHOLESALE } from 'codes';

// GLOBAL HELPERS/CONTEXT
import { RecordContext } from 'helpers/getRecordData';
import useRecordView from 'helpers/getRecordView';

// GLOBAL COMPONENTS
import Form from 'core/form/Form';

// LOCAL VARIABLES
import { SUB_TYPES_NEW } from '../variables';

// MAIN COMPONENT
const SaleSubtype = props => {

  // CONTEXT
  const { record: { inventory = {}, ...record } = {} } = useContext(RecordContext);
  const { values, setFieldValue } = useFormikContext() || {};
  const { isAdd } = useRecordView();

  // MEMOS
  const {
    sale_type_category_id
  } = useMemo(
    () => values || {},
    [values]
  )
  const {
    new_used
  } = useMemo(
    () => isAdd ? record : inventory,
    [record, inventory, isAdd]
  )
  const isNew = useMemo(
    () => parseInt(new_used) === NEW_USED.new.numeric,
    [new_used]
  )
  const isWholesale = useMemo(
    () => parseInt(sale_type_category_id) === RETAIL_WHOLESALE.wholesale.numeric,
    [sale_type_category_id]
  )

  // CALLBACKS
  const handleNewSubtype = useCallback(
    () => {
      if (isNew) {
        setFieldValue(`is_cpo`, false);
        setFieldValue(`is_loaner`, false);
      }
    },
    [isNew, setFieldValue]
  )

  return isWholesale ? null : isNew ? (
    <Form.Checklist
      name="sale_subtype_id"
      label="Subtype"
      type="radio"
      options={SUB_TYPES_NEW}
      onChange={handleNewSubtype}
      {...props}
      required
      formGroup={{
        className: 'py-0'
      }}
      list={{
        direction: 'horizontal',
        justify: 'start'
      }}
      fullWidth
  />
  ) : (
    <>
      <Form.YesNo
        label="Is this vehicle a loaner?"
        name="is_loaner"
        numeric={false}
        {...props}
        formGroup={{
          className: 'py-0'
        }}
        required
      />
      <Form.YesNo
        label="Is this vehicle a CPO?"
        name="is_cpo"
        numeric={false}
        {...props}
        formGroup={{
          className: 'py-0'
        }}
        required
      />
      <Form.PlainText
        label="Sale Subtype"
        name="sale_subtype_name"
        {...props}
      />
    </>
  )
}

// EXPORT
export default SaleSubtype
